import { createFileRoute } from '@tanstack/react-router';
import { PrestationParticipationsPage } from '@/features/prestation-participations/components/PrestationParticipationsPage';

export const Route = createFileRoute('/$commiteeSlug/prestation-participations/')({
  component: PrestationParticipationsPage,
});
